'use es6';

import { Record } from 'immutable';
import { Networks, LegacyFacebookScopes, FacebookScopes } from 'AdsUI/lib/Constants';

const isMissingScopes = (network, appScopes) => {
  if (network !== Networks.FACEBOOK) {
    return false;
  }

  return !!Object.values(FacebookScopes).find(permission => !appScopes.includes(permission)) && !!Object.values(LegacyFacebookScopes).find(permission => !appScopes.includes(permission));
};

export default Record({
  appScopes: null,
  userId: null,
  networkUserId: null,
  hubSpotUserId: null,
  authenticated: null,
  connectedAt: null,
  network: null,
  expiringSoon: null,
  expiresAt: null,

  isMissingManageScope() {
    return this.network === Networks.FACEBOOK && !this.appScopes.includes(FacebookScopes.ads_management);
  },

  isMissingScopes() {
    return isMissingScopes(this.network, this.appScopes);
  }

});